import { Component, OnInit } from '@angular/core';
import { WidgetDetailInstanceService } from '../widget-detail-instance.service';

@Component({
  selector: 'cw-widget-detail-dashboard',
  templateUrl: './widget-detail-dashboard.component.html',
  styleUrls: ['./widget-detail-dashboard.component.scss']
})
export class WidgetDetailDashboardComponent implements OnInit {

  constructor(private instance: WidgetDetailInstanceService) {
  }

  ngOnInit() {
  }

  get widget() {
    return this.instance.widget;
  }

}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/widget-detail-dashboard/widget-detail-dashboard.component.ts